export default `---
slug: russia
country: Russia
countryCode: RUS
continent: Europe
year: 2019
title: "Russia"
description: "Moscow and the Trans-Siberian ambitions — Red Square and beyond."
thumbnail: /images/travels/RUS/russia_thumb.jpg
relatedLinks: []
---
![russia](/images/travels/RUS/russia_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Russia and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
